import xlsx from 'xlsx';
import AppraisalOperation from '@/domain/dto/AppraisalOperation';

import Appraisal from '@/domain/dto/Appraisal';
import dataReaderConfig from '../../../domain/constants/default-xlsx-reader-config';

const DATE_SEPARATOR = '/';

function formatDateFromXLSFile(date) {
  // 2021-04-01
  if (!date) return date;
  return date.split(DATE_SEPARATOR).reverse().map(txt => (txt.length === 1 ? `0${txt}` : txt)).join('-');
}

const clean = value => {
  return typeof value === 'string' ? value.trim()
    .replace('$', '')
    .replace('%', '')
    .replace('.00', '')
    .replace(',', '') : value;
};

export default class GetAppraisalOperationsFromXLSFile {
  constructor() {
    this.dataReader = new window.FileReader();
    this.dataReaderConfig = dataReaderConfig;
  }

  async process(file) {
    return new Promise((resolve, reject) => {
      let operations = [];
      this.dataReader.onerror = () => {
        this.dataReader.abort();
        reject(new Error('error reading file'));
      };
      this.dataReader.onload = e => {
        const fileData = e.target.result;
        const workbook = xlsx.read(fileData, {
          type: this.dataReaderConfig.TYPE,
          cellText: this.dataReaderConfig.CELLTEXT,
          cellDates: this.dataReaderConfig.CELLDATES,
          dateNF: this.dataReaderConfig.DATENF
        });

        const sheetName = workbook.SheetNames[0];
        const workbookData = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName], {
          raw: this.dataReaderConfig.RAW
        });
        operations = [];
        let totals = [];
        totals = workbookData.pop() || [];
        try {
          workbookData.forEach(operationIn => {
            const item = new AppraisalOperation();
            const operation = {};
            Object.keys(operationIn).forEach(key => {
              operation[key.trim()] = operationIn[key].trim();
            });
            // ["Nº", "N° Operación CMF", "RUT", "Nombre Cliente", "Segmento", "Precio venta propiedad", "Valor de tasación", "Tasa anual de emisión", "Tasa mensual de emisión",
            // "Plazo en meses", "Meses de gracia", "LTV", " Monto otorgado (UF) ", " Valor cuota (UF) ", " Valor última cuota (UF) ", "Spread", "Tasa anual de endoso", "Tasa mensual de endoso",
            // "Fecha de suscripción", "Período primer aporte", "Fecha de endoso", "Fecha primer aporte a endosar", "Fecha último aporte", " Número de cuotas a endosar ",
            // "VAN fecha endoso", "Dirección Garantía",
            // "Comuna", "Ciudad", "Notaría"]

            item.setOperationNumber(clean(operation['N° Operación CMF']));
            item.setRut(clean(operation.RUT));
            item.setClientName(clean(operation['Nombre Cliente']));
            item.setSegment(clean(operation.Segmento));
            item.setPropertySalePrice(clean(operation['Precio venta propiedad']));
            item.setAppraisedValue(clean(operation['Valor de tasación']));
            item.setAnnualEmissionRate(clean(operation['Tasa anual de emisión']));
            item.setMonthlyIssuanceRate(clean(operation['Tasa mensual de emisión']));

            item.setSubsidy(clean(operation.Subsidio));
            item.setTermInMonths(clean(operation['Plazo en meses']));
            item.setMonthsOfGrace(clean(operation['Meses de gracia']));
            item.setLtv(clean(operation.LTV));
            item.setAmountAwarded(clean(operation['Monto otorgado (UF)']));
            item.setShareValue(clean(operation['Valor cuota (UF)']));
            item.setLastInstallmentValue(clean(operation['Valor última cuota (UF)']));
            item.setSpread(clean(operation.Spread));
            item.setAnnualEndorsementFee(clean(operation['Tasa anual de endoso']));
            item.setMonthlyEndorsementFee(clean(operation['Tasa mensual de endoso']));

            item.setSubscriptionDate(formatDateFromXLSFile(clean(operation['Fecha de suscripción'])));
            item.setPeriodOfFirstContribution(formatDateFromXLSFile(clean(operation['Período primer aporte'])));
            item.setEndorsementDate(formatDateFromXLSFile(clean(operation['Fecha de endoso'])));
            item.setDateOfFirstContributionToEndorse(formatDateFromXLSFile(clean(operation['Fecha primer aporte a endosar'])));
            item.setDateOfLastContribution(formatDateFromXLSFile(clean(operation['Fecha último aporte'])));

            item.setNumberOfInstallmentsToEndorse(clean(operation['Número de cuotas a endosar']));
            item.setVANEndorsementDate(clean(operation['VAN fecha endoso']));
            item.setWarrantyDirection(clean(operation['Dirección Garantía']));
            item.setCommune(clean(operation.Comuna));
            item.setCity(clean(operation.Ciudad));
            item.setNotary(clean(operation['Notaría']));
            item.setOverduePayments(Number(clean(operation['Cuotas morosas'])));

            operations.push(item);
          });
        } catch (error) {
          reject(error);
        }
        const apraisal = new Appraisal(totals[' Monto otorgado (UF) '], totals['VAN fecha endoso'], operations);
        resolve(apraisal);
      };
      this.dataReader.readAsBinaryString(file);
    });
  }
}
